function _(n,r,t){r.exports=function(n){return n=Number(n),isNaN(n)||0===n?n:n>0?1:-1}}
//# sourceMappingURL=shim.min.js.map